import {useStringFeatureFlag} from "ub-feature-flagging-react";

export function useStringFeatureFlagWrapper(flag: string, defaultValue: string) {
    return useStringFeatureFlag(flag, defaultValue);
}
